export default __webpack_public_path__ + "static/media/live-gfe-video.985c219b.svg";